import multiRequest from '../shared/multiRequest';

const getAvailableChangeNumberAdministrator = () => {
  return multiRequest([
    {
      url: 'customer/validateChangeAdministrator',
      method: 'GET',
    },
  ]);
};

const getCustomerAccountList = () => {
  return multiRequest([
    {
      url: 'customer/accounts',
      method: 'GET',
    },
  ]);
};

const getProfileInfo = () =>
  multiRequest([
    {
      url: 'customer/profile-info',
      method: 'GET',
    },
  ]);

const postProfileInfo = ({
  email,
  firstName,
  lastName,
  mobilePhone,
  rut,
  token,
}) =>
  multiRequest([
    {
      url: 'customer/profile-info',
      method: 'POST',
      data: { email, firstName, lastName, mobilePhone, rut, token },
    },
  ]);

const savePreferences = data =>
  multiRequest([{ url: 'customer/save-preferences', method: 'POST', data }]);

const getMyLines = (cellphone, accountId, pageNumber) => {
  const path = 'customer/my-lines';
  const url =
    cellphone && accountId && pageNumber
      ? `${path}?cellphone=${cellphone}&accountId=${accountId}&pageNumber=${pageNumber}`
      : path;
  return multiRequest([
    {
      url,
      method: 'GET',
    },
  ]);
};

const validateWomNumber = (number, scope) => {
  return multiRequest([
    {
      url: `customer/validate-wom-number?cellphone=${number}&scope=${scope}`,
      method: 'GET',
    },
  ]);
};

const infoDevice = number => {
  return multiRequest([
    {
      url: `customer/info-device?cellphone=${number}`,
      method: 'GET',
    },
  ]);
};

const suscriptorSimcard = () => {
  return multiRequest([
    {
      url: `customer/simcard-resources`,
      method: 'GET',
    },
  ]);
};

const CustomerService = {
  getAvailableChangeNumberAdministrator,
  getCustomerAccountList,
  getProfileInfo,
  postProfileInfo,
  savePreferences,
  getMyLines,
  validateWomNumber,
  infoDevice,
  suscriptorSimcard,
};

export default CustomerService;
